import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IState } from 'shared/interfaces/state.interface';
import { TPaginationRequest } from 'shared/types';
import { initialStore } from '../initial-store';

const productSlice = createSlice({
  name: 'product',
  initialState: initialStore.product,
  reducers: {
    setProductData: (state, { payload }) => {
      state.dataProducts = payload?.data?.products || [];
      state.count = payload?.data?.count || 0;
      state.isLoading = false;
    },
    getProductData: (
      state,
      data: PayloadAction<TPaginationRequest | undefined>
    ) => {
      if (!state.isLoading) {
        state.isLoading = true;
      }
    },
    createProductData: (state, { payload }) => {
      state.isLoading = true;
    },
    actionFail: (state) => {
      state.isLoading = false;
      state.dataProductVariations.isLoading = false;
    },
    buildProductPage: (state, { payload }) => {
      state.isLoading = true;
    },
    updateProductData: (state, { payload }) => {
      if (!state.isLoading) {
        state.dataIndividualProduct.isLoadingUpdate = true;
      }
    },
    updateProductSuccess: (state, { payload }) => {
      state.dataIndividualProduct.data = payload;
      state.dataIndividualProduct.isLoadingUpdate = false;
    },
    updateProductFail: (state) => {
      state.dataIndividualProduct.isLoadingUpdate = false;
    },

    setIndividualProductInfo: (state, { payload }) => {
      const data = payload;
      state.dataIndividualProduct.data = {
        ...data
      };
      state.isLoading = false;
    },
    setProduct: (state, { payload }) => {
      state.dataIndividualProduct.data = {
        ...payload
      };
      state.isLoading = false;
    },
    getECommerceProductVariationsData: (state, data) => {
      if (!state.dataProductVariations.isLoading) {
        state.dataProductVariations.isLoading = true;
      }
    },
    mapEcommerceProductVariation: (state, { payload }) => {
      // trigger loading while mapping is in progress
      if (!state.dataProductVariations.isLoading) {
        state.dataProductVariations.isLoading = true;
      }
    },
    mapEcommerceProductVariationSuccess: (state, { payload }) => {
      // mapping succeeded; stop loading. UI refresh is handled by sagas (re-fetch)
      state.dataProductVariations.isLoading = false;
    },
    mapEcommerceProductVariationFail: (state) => {
      state.dataProductVariations.isLoading = false;
    },
    setProductVariationsData: (state, { payload }) => {
      state.dataProductVariations.allProductsVariations =
        payload?.data?.mappings || [];
      state.dataProductVariations.count = payload?.data?.count || 0;
      state.dataProductVariations.isLoading = false;
    }
  }
});

export const {
  setProductData,
  getProductData,
  createProductData,
  actionFail,
  buildProductPage,
  setIndividualProductInfo,
  updateProductFail,
  updateProductData,
  updateProductSuccess,
  setProduct,
  getECommerceProductVariationsData,
  mapEcommerceProductVariation,
  mapEcommerceProductVariationSuccess,
  mapEcommerceProductVariationFail,
  setProductVariationsData
} = productSlice.actions;

export const { reducer } = productSlice;

// Selectors
export const getProductsSelector = (state: IState) => {
  return state && state?.product?.dataProducts;
};

export const getProductsLoadingSelector = (state: IState) =>
  state && state?.product?.isLoading;

export const getProductsLoadingUpdateSelector = (state: IState) =>
  state && state?.product?.dataIndividualProduct?.isLoadingUpdate;

export const getProductIndividualSelector = (state: IState) =>
  state && {
    data: state.product.dataIndividualProduct.data
  };

export const getProductCount = (state: IState) =>
  state && state?.product?.count;

export const getECommerceProductVariationsSelector = (state: IState) => {
  return state && state?.product?.dataProductVariations?.allProductsVariations;
};

export const getECommerceProductVariationsCount = (state: any) =>
  state && state?.product?.dataProductVariations?.count;

export const getECommerceProductVariationsLoadingSelector = (state: any) =>
  state && state?.product?.dataProductVariations?.isLoading;
